import { Checkbox } from '@/components/Checkbox';
import { useReflectionVideosStore } from '../../store/useSearchStore';

export const Filters = () => {
  const keysStages = useReflectionVideosStore((state) => state.keysStages);
  const filters = useReflectionVideosStore((state) => state.filters);
  const page = useReflectionVideosStore((state) => state.page.page);

  return (
    <div className="mt-sh-30 flex flex-col gap-4 rounded-[16px] border border-primary-500 p-[16px]">
      <div>
        <p className="mb-2 font-cadiz text-sh-xs font-bold">{page?.keyStageLabel}</p>
        <div className="flex max-w-[700px] flex-wrap">
          {keysStages?.map((keyStageItem) => {
            const keyStage = keyStageItem?.keyStage;
            const documentId = keyStageItem?.documentId;

            return (
              <Checkbox
                key={keyStage}
                checked={filters.keyStages?.some((keyStageDocumentId) => keyStageDocumentId === documentId) || false}
                value={keyStage}
                label={keyStage}
                onCheckedChange={(checked) => {
                  if (checked) {
                    useReflectionVideosStore.setState({
                      filters: {
                        keyStages: [...(filters.keyStages || []), documentId],
                      },
                    });
                    return;
                  }

                  useReflectionVideosStore.setState({
                    filters: {
                      keyStages: filters.keyStages?.filter((keyStageDocumentId) => keyStageDocumentId !== documentId),
                    },
                  });
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
